import { SERVER_RESPONSE_STATUS_OK } from '@firebird-web/shared-constants';
import { ServerResponse } from '@firebird-web/shared-interfaces';
import {
  catchError,
  filter,
  map,
  Observable,
  of,
  tap,
  throwIfEmpty,
} from 'rxjs';

export function requestVersioned<T>(
  versions: Map<string, ServerResponse<T>>,
  cacheKey: string,
  request: (version?: string) => Observable<ServerResponse<T>>
): Observable<ServerResponse<T>> {
  return request(versions.get(cacheKey)?.version).pipe(
    catchError(() => of(null)),
    map((response) =>
      response?.status === SERVER_RESPONSE_STATUS_OK && !!response.data
        ? response
        : versions.get(cacheKey)
    ),
    filter((response): response is ServerResponse<T> => !!response?.data),
    throwIfEmpty(),
    tap((response) => versions.set(cacheKey, response))
  );
}
